import { stripePromise } from "src/utils/StripePromise"
import { mutateApi } from "src/utils/api/ApiMethods"

// The server honours the requested types only as a subset of the quote's accepted methods.
export const initializePaymentMethodSetup =
  (quoteId) =>
  ({ acceptedPaymentMethods } = {}) => {
    return mutateApi({
      url: `/contract_quotes/${quoteId}/payment_methods/setup`,
      method: "POST",
      data: { accepted_payment_methods: acceptedPaymentMethods },
    })
  }

export const cancelPaymentMethodSetup = (quoteId) => (setupIntentId) =>
  mutateApi({
    url: `/contract_quotes/${quoteId}/payment_methods/setup/${setupIntentId}`,
    method: "DELETE",
  })

// The verify endpoint takes the payment method id, not the setup intent id.
export const createPaymentMethod =
  (quoteId) => async (setupIntentId, setupIntentClientSecret) => {
    const stripe = await stripePromise
    const { setupIntent, error } = await stripe.retrieveSetupIntent(
      setupIntentClientSecret
    )

    if (error) {
      throw error
    }

    return mutateApi({
      url: `/contract_quotes/${quoteId}/payment_methods`,
      method: "POST",
      data: { stripe_payment_method_id: setupIntent.payment_method },
    })
  }
